module.exports = __webpack_public_path__ + "static/media/forwardArrowDisabled.e70b63af.svg";